<template>
  <el-container>
    <el-header class="head !h-[56] pl-[0] flex justify-between bg-[#00152a] items-center pr-[32]">
      <div class="flex items-center">
        <p class="h-[56] w-[60] bg-[theme] rounded-tr-[12] text-center leading-[56]">
     
          <i v-if="conf.logoIcon" class="iconfont-logo t-[#ffffff] mr-[5] t-[37]" :class="conf.logoIcon"></i>
          <img v-else class="w-[28] mr-[5]" :src="require(`@/assets/img/city/${conf.city}/logo.png`)" alt="" />
        </p>
        <p class="t-[#fff] pl-[18] t-[16] font-700">{{ conf.name }}</p>
        <!-- <p class="border-[1] border-[#fff] border-solid py-[2] ml-[8] px-[8] t-[#fff] t-[12]" v-if="supplierEnterpriseType == 0">融资企业</p> -->
        <p class="border-[1] border-[#fff] border-solid py-[2] ml-[8] px-[8] t-[#fff] t-[12] rounded-[2]"
          v-if="supplierEnterpriseType == 1">核心企业</p>
      </div>
      <div class="flex t-[#fff]">
        <div class="relative mr-[36] cursor-pointer" @click="push({ path: '/notify/index' })">
          <i class="icon t-[18]">&#xe62d;</i>
          <span>消息</span>
          <span v-if="unreadCount"
            class="absolute w-[16] text-center leading-[16] h-[16] top-[-10] right-[-10] t-[#fff] bg-[#FF0000] rounded-[100] t-[10]">{{
              unreadCount }}</span>
        </div>
        <a :href="ENV.official" target="_blank" class="relative no-underline t-[#fff] block mr-[80] cursor-pointer">
          <i class="icon t-[18]">&#xe67d;</i>
          <span>官网</span>
        </a>

        <el-dropdown class="headimg-box" @command="handleCommand">
          <div class="flex items-center cursor-pointer">
            <p class="px-[4] t-[14] t-[#fff]">
              {{ user && user.realName }}
            </p>
            <p class=""><i class="icon t-[#fff]">&#xe6c6;</i></p>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="info">个人信息</el-dropdown-item>
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside :width="isCollapse ? '60px' : '170px'" class="shadow aside bg-[#fff] p-[8] relative">
        <ul>
          <template v-for="v in menuJson">
            <li class="py-[3] no-select">
              <el-popover :disabled="!isCollapse || !v.children.length" placement="right" width="150" trigger="hover">
                <template v-slot:reference>
                  <div @click.stop="v.opened = !v.opened">
                    <el-tooltip :disabled="!isCollapse || v.children.length" :content="v.name" placement="left">
                      <div @click="push({ path: v.path })"
                        :class="{ 'active bg-[#F2F6FF] ': reactiveMenu(v.paths) && !v.children.length }"
                        class="flex items-center pl-[12] pr-[4] rounded-[4] justify-between leading-[32] cursor-pointer">
                        <p class="flex items-center">
                          <i class="icon t-[20] t-[#9e9b9b] mr-[8]"
                            :class="{ '!t-[theme]': reactiveMenu(v.paths) && !v.children.length }" v-html="v.icon"></i>
                          <span class="t-[#303133]"
                            :class="{ '!t-[theme]': reactiveMenu(v.paths) && !v.children.length }" v-if="!isCollapse">{{
                              v.name }}</span>
                        </p>
                        <i class="icon t-[10] t-[#909399]" v-if="v.children.length && !isCollapse"
                          v-html="v.opened ? '&#xe6cc;' : '&#xe646;'"></i>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
                <!-- 二级菜单 -->
                <ul>
                  <li @click="push({ path: c.path })"
                    :class="{ 'active bg-[#F2F6FF] !t-[theme]': reactiveMenu([c.path]) }"
                    class="leading-[32] pl-[10] rounded-[4] py-[3] cursor-pointer" v-for="(c, i) in v.children"
                    :key="i">{{
                      c.name }}</li>
                </ul>
              </el-popover>
              <el-collapse-transition v-if="v.children.length && !isCollapse">
                <!-- 二级菜单 -->
                <ul v-show="v.opened" class="pl-[20] pt-[5]">
                  <li @click="push({ path: c.path })"
                    :class="{ 'active bg-[#F2F6FF] !t-[theme]': reactiveMenu([c.path]) }"
                    class="leading-[32] pl-[20] rounded-[4] py-[3] t-[#303133] cursor-pointer"
                    v-for="(c, i) in v.children" :key="i">{{ c.name }}</li>
                </ul>
              </el-collapse-transition>
            </li>
          </template>
        </ul>
        <i class="icon fold absolute right-[20] bottom-[20] t-[24] t-[#909399]"
          @click="isCollapse = !isCollapse">&#xe65c;</i>
      </el-aside>
      <el-main class="p-[0]" :style="contentStyle">
        <div class="bg-[#fff] py-[12] pl-[16] flex flex-wrap items-center" v-if="getBreadcrumb.length">
          <p v-if="getBreadcrumb.length > 1" @click="$router.back()"
            class="w-[20] leading-[17] mr-[8] border-[1] border-[#c3cad9] border-solid rounded-[2] text-center">
            <i class="icon t-[10]">&#xe6cb;</i>
          </p>
          <el-breadcrumb separator="/" class="t-[12] leading-[20]">
            <el-breadcrumb-item v-for="(v) in getBreadcrumb" :key="v.name"
              :to="{ path: v.path || $route.fullPath }">{{ v.name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <transition name="el-zoom-in-top">
          <div class="mb-[10]" v-show="tips.msg">
            <el-alert @close="() => {
              tips.msg = '';
              tips.type = 'error';
            }
              " :title="tips.msg" :type="tips.type" show-icon>
            </el-alert>
          </div>
        </transition>
        <div class="px-[16] pt-[10]">
          <keep-alive :include="includeView">
            <router-view v-loading="showLoading" :key="$route.fullPath" />
          </keep-alive>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import menuJson from "../assets/js/menu";
import breadcrumb from "../assets/js/breadcrumb";
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      includeView: ["CertificateList"],
      menuJson: [],
      isCollapse: false,
      showLoading: false,
      unreadCount: 0,
      supplierEnterpriseType: -1,
      tips: {
        msg: "",
        type: "error",
      },

      contentStyle: {
        height: window.innerHeight - 60 + "px",
        width: Math.max(window.innerWidth - 200, 1200) + "px",
      },
      enterprise: {},
      user: {},
    };
  },
  watch: {
    $route(to) {
      console.log(to);
    },
  },
  computed: {
    getBreadcrumb() {
      return breadcrumb[this.$route.fullPath] || breadcrumb[this.$route.path] || [];
    },
  },
  methods: {
    reactiveMenu(pathArrary = []) {
      // 首页
      if (this.$route.path == "/" && pathArrary[0] == "/") {
        return true;
      }
      return pathArrary.indexOf(this.$route.path) > -1;
    },
    handleCommand(command) {
      if (command == "info") {
        this.push({ path: "/user/account/info" });
      }
      if (command == "password") {
        this.push({ path: "/user/account/modifyPasw" });
      }
      if (command == "exit") {
        ajax.post({
          url: "/supplyChain/auth/logout",
          data: {},
          success: (res) => {
            if (res) {
              localStorage.clear();
              sessionStorage.clear();
              this.back({ path: "/login" });
            }
          },
          fail: () => { },
        });
      }
    },
    /**
     * @author 伟健 / 张
     * @name 消息未读数
     */
    getUnreadCount() {
      ajax.post({
        url: "/supplyChain/noticeSupervise/unreadCount",
        data: {},
        self: this,
        success: (res) => {
          this.unreadCount = res;
        },
        fail: () => { },
      });
    },
    /**
     * @author 伟健 / 张
     * @name 当前用户信息
     */
    getCurrent(cb) {
      ajax.post({
        url: "/supplyChain/user/current",
        data: {},
        success: (res) => {
          if (res && res.user) {
            cb && cb(res);
            localStorage.setItem("current", JSON.stringify(res));
          }
        },
        fail: () => {
          // this.push({ path: "/login" });
        },
      });
    },
  },
  mounted() {
    // 监听加载中状态的开启

    Mirror.watch("update_unreadCount", () => {
      this.getUnreadCount();
    });

    this.getCurrent();

    if (localStorage.getItem("current")) {
      let current = JSON.parse(localStorage.getItem("current"));
      if (current.enterprise) {
        this.enterprise = current.enterprise;
        this.menuJson = menuJson[current.enterprise.supplierEnterpriseType];
        this.supplierEnterpriseType = current.enterprise.supplierEnterpriseType;
      }
      if (current.user) {
        this.user = current.user;
      }
    }
    // 监听窗口变化
    window.onresize = () => {
      this.contentStyle.height = window.innerHeight - 60 + "px";
      this.contentStyle.width = Math.max(window.innerWidth - 200, 1200) + "px";
    };
  },
  created() {
    this.getUnreadCount();
  },
};
</script>
<style lang="less">
.shadow {
  box-shadow: 2px 0px 12px 0px rgba(0, 0, 0, 0.05);
}

.aside {
  transition: all 0.3s;
}

#app .el-breadcrumb {
  font-size: 12px;
  line-height: 20px !important;
  font-weight: 400;

  .el-breadcrumb__inner {
    color: #606266 !important;
    font-weight: 400;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #000000 !important;
    font-weight: 400;
  }
}
</style>
 <style>.\!h-\[56\] {
    height: 56px !important
}
.pl-\[0\] {
    padding-left: 0px
}
.bg-\[\#00152a\] {
    background-color: #00152a
}
.pr-\[32\] {
    padding-right: 32px
}
.h-\[56\] {
    height: 56px
}
.w-\[60\] {
    width: 60px
}
.bg-\[theme\] {
    background-color: #008AA6
}
.rounded-tr-\[12\] {
    border-top-right-radius: 12px
}
.leading-\[56\] {
    line-height: 56px
}
.t-\[\#ffffff\] {
    color: #ffffff
}
.mr-\[5\] {
    margin-right: 5px
}
.t-\[37\] {
    font-size: 37px
}
.w-\[28\] {
    width: 28px
}
.t-\[\#fff\] {
    color: #fff
}
.pl-\[18\] {
    padding-left: 18px
}
.t-\[16\] {
    font-size: 16px
}
.border-\[1\] {
    border-width: 1px
}
.border-\[\#fff\] {
    border-color: #fff
}
.py-\[2\] {
    padding-top: 2px;
    padding-bottom: 2px
}
.ml-\[8\] {
    margin-left: 8px
}
.px-\[8\] {
    padding-left: 8px;
    padding-right: 8px
}
.t-\[12\] {
    font-size: 12px
}
.rounded-\[2\] {
    border-radius: 2px
}
.mr-\[36\] {
    margin-right: 36px
}
.t-\[18\] {
    font-size: 18px
}
.w-\[16\] {
    width: 16px
}
.leading-\[16\] {
    line-height: 16px
}
.h-\[16\] {
    height: 16px
}
.top-\[-10\] {
    top: -10px
}
.right-\[-10\] {
    right: -10px
}
.bg-\[\#FF0000\] {
    background-color: #FF0000
}
.rounded-\[100\] {
    border-radius: 100px
}
.t-\[10\] {
    font-size: 10px
}
.mr-\[80\] {
    margin-right: 80px
}
.px-\[4\] {
    padding-left: 4px;
    padding-right: 4px
}
.t-\[14\] {
    font-size: 14px
}
.bg-\[\#fff\] {
    background-color: #fff
}
.p-\[8\] {
    padding: 8px
}
.py-\[3\] {
    padding-top: 3px;
    padding-bottom: 3px
}
.bg-\[\#F2F6FF\] {
    background-color: #F2F6FF
}
.pl-\[12\] {
    padding-left: 12px
}
.pr-\[4\] {
    padding-right: 4px
}
.rounded-\[4\] {
    border-radius: 4px
}
.leading-\[32\] {
    line-height: 32px
}
.t-\[20\] {
    font-size: 20px
}
.t-\[\#9e9b9b\] {
    color: #9e9b9b
}
.mr-\[8\] {
    margin-right: 8px
}
.\!t-\[theme\] {
    color: #008AA6 !important
}
.t-\[\#303133\] {
    color: #303133
}
.t-\[\#909399\] {
    color: #909399
}
.pl-\[10\] {
    padding-left: 10px
}
.pl-\[20\] {
    padding-left: 20px
}
.pt-\[5\] {
    padding-top: 5px
}
.right-\[20\] {
    right: 20px
}
.bottom-\[20\] {
    bottom: 20px
}
.t-\[24\] {
    font-size: 24px
}
.p-\[0\] {
    padding: 0px
}
.py-\[12\] {
    padding-top: 12px;
    padding-bottom: 12px
}
.pl-\[16\] {
    padding-left: 16px
}
.w-\[20\] {
    width: 20px
}
.leading-\[17\] {
    line-height: 17px
}
.border-\[\#c3cad9\] {
    border-color: #c3cad9
}
.leading-\[20\] {
    line-height: 20px
}
.mb-\[10\] {
    margin-bottom: 10px
}
.px-\[16\] {
    padding-left: 16px;
    padding-right: 16px
}
.pt-\[10\] {
    padding-top: 10px
}
.flex {
    display: flex
}
.justify-between {
    justify-content: space-between
}
.items-center {
    align-items: center
}
.text-center {
    text-align: center
}
.font-700 {
    font-weight: 700
}
.border-solid {
    border-style: solid
}
.relative {
    position: relative
}
.cursor-pointer {
    cursor: pointer
}
.absolute {
    position: absolute
}
.no-underline {
    text-decoration: none
}
.block {
    display: block
}
.flex-wrap {
    flex-wrap: wrap
}</style>